import type { IconLoaders } from "../types";

/** Feedback and state: success, info, warning, error */
export const statusIcons = {
    check: () => import("./check"),
    check_bold: () => import("./check_bold"),
    check_circle: () => import("./check_circle"),
    check_circle_filled: () => import("./check_circle_filled"),
    check_heavy: () => import("./check_heavy"),
    check_outline: () => import("./check_outline"),
    check_small: () => import("./check_small"),
    check_small_thick: () => import("./check_small_thick"),
    check_thin: () => import("./check_thin"),
    check_tiny: () => import("./check_tiny"),
    circle_close: () => import("./circle_close"),
    clock: () => import("./clock"),
    exclamation_circle_filled: () => import("./exclamation_circle_filled"),
    exclamation_triangle: () => import("./exclamation_triangle"),
    history: () => import("./history"),
    info_circle: () => import("./info_circle"),
    info_circle_bold: () => import("./info_circle_bold"),
    info_circle_filled: () => import("./info_circle_filled"),
    information_circle: () => import("./information_circle"),
    progress_check: () => import("./progress_check"),
    shield_check: () => import("./shield_check"),
    snail: () => import("./snail"),
} satisfies IconLoaders;
